import { render, staticRenderFns } from "./evaluation.vue?vue&type=template&id=1a7f1b13&scoped=true&"
import script from "./evaluation.vue?vue&type=script&lang=ts&"
export * from "./evaluation.vue?vue&type=script&lang=ts&"
import style0 from "./evaluation.vue?vue&type=style&index=0&id=1a7f1b13&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7f1b13",
  null
  
)

export default component.exports